import { render } from "./MOptionGroup.vue?vue&type=template&id=3514cfea"
import script from "./MOptionGroup.vue?vue&type=script&lang=js"
export * from "./MOptionGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__